function filterCompatibleModels(input) {
  const filter = input.value.toLowerCase();

  // Find the nearest wrapper (your description outer div)
  const wrapper = input.closest("div");

  // Filter ALL compatible-parts-list spans inside that wrapper
  const lists = wrapper.querySelectorAll(".compatible-parts-list");

  lists.forEach(list => {
    const items = list.querySelectorAll("span");
    items.forEach(item => {
      const text = item.textContent.toLowerCase();
      item.style.display = text.includes(filter) ? "" : "none";
    });
  });
}
